<template>
  <div class="payment-failed">
    <div
      v-if="paymentInfo"
      class="container"
    >
      <h1>{{ $t("receipt.payment-failed") }}</h1>
      <TransactionDetails :payment-info="transactionInfo.payment" />
      <router-link
        :to="{
          name: 'Pay',
          params: {
            qrCode: transactionInfo.payment.qrCode,
            currency: transactionInfo.payment.currency,
          },
        }"
        custom
        v-slot="{ navigate }"
      >
        <el-button
          type="primary"
          class="primary-button"
          @click="navigate"
          :style="{ background: primaryColor }"
        >
          {{ $t("receipt.retry") }}
        </el-button>
      </router-link>
    </div>
    <div v-else>
      {{ $t("receipt.transaction-not-found") }}
    </div>
  </div>
</template>

<script>
import TransactionDetails from './ReceiptTableTransactionDetails.vue';

export default {
  name: "PaymentFailed",
  components: {
    TransactionDetails,
  },
  props: {
    transactionInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    primaryColor: function () {
      return this.transactionInfo?.schemaPrimaryColor ?? "#FF8A00";
    },
    paymentInfo() {
      return this.transactionInfo?.payment?.id ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-failed {
  text-align: center;
  max-width: 640px;
  padding: 0 20px;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 24px;
  }

  .primary-button {
    margin-top: 20px;
  }
}
</style>
